// extracted by mini-css-extract-plugin
module.exports = {"closeTag":"close-tag_closeTag__3uU42","text":"close-tag_text__uAqMc"};